import { Injectable } from '@angular/core';
import Hotjar from '@hotjar/browser';
import { EnvironmentService } from '../environment-service/environment.service';
import { RudderStackService } from '@services/rudderstack/rudderstack.service';
import posthog from 'posthog-js';

@Injectable({
  providedIn: 'root',
})
export class HotjarService {
  constructor(private rudderStackService: RudderStackService) {
    const siteId = EnvironmentService.environment.hotjar.siteId;
    const version = EnvironmentService.environment.hotjar.version;

    Hotjar.init(+siteId, +version);

    this.rudderStackService.onReady$.subscribe(() => {
      const userId = this.rudderStackService.getAnonymousId();
      userId && this.identify(userId, {});
    });
  }

  isEnabled(): boolean {
    return Hotjar.isReady();
  }

  event(eventName: string) {
    if (this.isEnabled()) {
      Hotjar.event(eventName);
    }
    posthog.capture('hotjar_event', {
      message: `Hotjar event: ${eventName}`,
      category: 'hotjar',
    });
  }

  identify(
    userId: string,
    payload: Record<string | number, string | number | Date | boolean>,
  ) {
    if (this.isEnabled()) {
      Hotjar.identify(userId, payload);
    }
  }
}
